import algoliasearch from "algoliasearch/lite";
import singletonRouter from "next/router";
import React, { useState, useEffect, useReducer } from "react";
import { createInstantSearchRouterNext } from "react-instantsearch-router-nextjs";
import {
  Configure,
  InstantSearch,
  InstantSearchSSRProvider,
  SearchBox,
} from "react-instantsearch";
import IntroComp from "./IntroComp";

import SortComp from "./SortComp/index";
import { createFilterInitialObj } from "./collection-utils";
import ProductItemTile from "@/components/ProductListingComp/ProductItemTile";
import PLPFilter from "./PlpFilter/index";
let HitComponent = ({ hit, itemkey }) => <ProductItemTile hit={hit} itemkey={itemkey} />;

import { InjectedInfiniteHits } from "@/components/InjectedHits"
import SuperbrandPLP from "../BuilderIO/SuperBrands";
import { getSEOModelData } from "@/helpers/builderHelper";
import { ContentTilePLP1, ContentTilePLP2 } from "./BuilderContentTileNew";
import BreadCrumb from "./BreadCrumb";
import { breadcrumbAttributes } from "./filters-utils";
import SeoDefinition from "../Header/SeoDefinition";
import TotalCount from "./TotalCount";
import { defaultPaginationParams, getPaginationParamsByPageNo, paginationHelper } from "./pagination-utils";
import CustomMDesktopPagination from "./CustomDesktopPagination";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { removeTargetAttr } from "@/helpers/generalHelper";
import { useSelector } from "react-redux";
import { setCustomer } from "../common/Nosto";
import PLPQuickLinks from "../BuilderIO/ImageQuickLinks/ImageQuickLinks.builder";

const client = algoliasearch(
  process.env.ALGOLIA_APPLICATION_ID,
  process.env.ALGOLIA_SEARCH_API_KEY
);

function Collection({ serverRender, serverState, serverUrl, serverPath, contentTilePLPOne, contentTilePLPTwo, seoDataa, isMobile, offset, length, nbHits, quickLinks, oliSearch }) {
  if(isMobile) {
   HitComponent = ({ hit, itemkey }) => <ProductItemTile hit={hit} itemkey={itemkey} isMobile={isMobile} />;
  }
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const position1 = 6;
  const position2 = isTablet ? 19 : 20;
  /* Create initial state */
  let initState;
  let configure;
  let enableContentTile;
  let titleData;


  /* To create path and query for initial filter */
  let queryParams;
  let pageNo
  let pathArray = serverPath;
  pathArray = pathArray.split('?');
  if (pathArray[1]) {
    const urlParams = new URLSearchParams(pathArray[1]);
    queryParams = urlParams.get('query');
    // fetch page number from url returned by server
    pageNo = urlParams.get('page');
  }
  pathArray = pathArray[0];
  pathArray = pathArray.replace('/index.html', "");
  pathArray = pathArray.replace('/', '');
  pathArray = pathArray.split('/');

  let filterableItem = createFilterInitialObj(pathArray, queryParams, offset, length);
  initState = filterableItem.initState;
  configure = filterableItem.configure;
  titleData = filterableItem.titleData;
  enableContentTile = contentTilePLPOne || contentTilePLPTwo ? true : false;
  seoDataa = { ...seoDataa, ...titleData }
  let indexName = Object.keys(initState)[0] || process.env.SHOPIFY_PRIMARY_INDEX;
  let initialRefinement = Object.keys(filterableItem.initialRefinement).length ? filterableItem.initialRefinement : false;
  if (initialRefinement) {
    initialRefinement = filterableItem.initialRefinement?.refinementList || false;
  }
  // const myRouter = {
  //   router: createInstantSearchRouterNext({
  //     serverUrl: serverUrl,
  //     singletonRouter,
  //     routerOptions: {
  //       createURL({ qsModule, location, routeState }) {
  //         if (Object.keys(routeState[indexName]).length === 0) {
  //           return location.href.replace(location.origin, "")
  //         }
  //         const { origin, pathname, hash, href, search } = location;
  //         let queryString = qsModule.stringify(routeState);
  //         let searchParams = new URLSearchParams(search)
  //         let pageNumber = Number(searchParams.get('page'))
  //         let searchQuery = searchParams.get('query');

  //         //  if url contains UTM parameters
  //         if (serverUrl.includes("utm_")) {
  //           // get the search params array from the search string
  //           let utmParams = queryParamsToArray(search);
  //           // UTM params would be those where the key starts with "utm_"
  //           if(utmParams?.length){
  //             utmParams = utmParams?.filter(utm => {
  //               let utmKey = Object.keys(utm)[0];
  //               if (utmKey.includes('utm_')) {
  //                 return utm;
  //               }
  //             })
  //             // from the UTM Params array generate the search params string
  //             utmParams = arrayToQueryParams(utmParams);
  //             // append the new UTM param string with existing query param string
  //             queryString = queryString + "&" + utmParams;
  //           }
  //           else{
  //             return
  //           }
  //         }
          
  //         if (searchQuery) {
  //           // queryString = queryString + "&query=" + searchQuery;
  //         }
  //         if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber !== 1) {
  //           queryString = queryString + "&page=" + pageNumber;
  //         }
  //         if (intervalRef.current) {
  //           intervalRef.current = false;
  //           if (href.includes('?')) {
  //             return `${origin}${pathname}?${queryString}${hash}`
  //           }
  //           else {
  //             return `${origin}${pathname}${hash}`;
  //           }
  //         }
  //         if (queryString) {
  //           return `${origin}${pathname}?${queryString}${hash}`;
  //         }
  //         return `${origin}${pathname}?${queryString}${hash}`;
  //       },
  //       parseURL({ qsModule, location }) {
  //         return qsModule.parse(location.search.slice(1));
  //       }
  //     }
  //   }),

  // }

  //p1 brand video fix
  const [plpscroll, plpsetScroll] = useState(false);
  if (typeof window === "object") {
    let plpSection = document.querySelector(".plp-section");
    // window.addEventListener("scroll", () => {
    //   if (plpSection) {
    //     if (plpSection.getBoundingClientRect().top.toFixed() <= 0) {
    //       plpsetScroll(true);
    //     }
    //     else {
    //       plpsetScroll(false);
    //     }
    //   }
    // });
  }


  //conditional code to setup nosto carousal id on page type
  let relativePath = serverPath;
  const isDesignerPLP = relativePath.includes("/designer");
  const isNewArrivalsPLP = relativePath.includes("/new-arrivals");
  const isCollectionPLP = relativePath.includes("/collection/");

  // created default pagination object from the offset, length, nbHits returned by server
  let alterDefaultPaginationParams = defaultPaginationParams
  if(pageNo && pageNo != defaultPaginationParams.currentPage) {
    const {currentPage, offset, length} = getPaginationParamsByPageNo({page: Number(pageNo)},{enableContentTile: enableContentTile},true)
    alterDefaultPaginationParams = {...defaultPaginationParams, currentPage, offset, length, totalFetchedProducts: nbHits, totalPages: Math.ceil(nbHits/defaultPaginationParams.productsLengthPerPage)}
  }
  // created default pagination object from the offset, length during server render used to pass to Configure component
  if(serverRender) {
    alterDefaultPaginationParams = {...defaultPaginationParams, offset, length}
  }
  // handle custom mobile pagination
  const [paginationState, dispatch] = useReducer(paginationHelper, alterDefaultPaginationParams)

  const [renderFromServer, setRenderFromServer] = useState(true)
  const [isRequestingFromMobile, setIsRequestingFromMobile] = useState(isMobile)
  const [isClient, setIsClient] = useState(false);
  let logUser = useSelector((state) => state.loginUser);
  // dynamically change the pagination params based on the page having content tile and / or a mobile device
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const pageNumberInURL = searchParams.get('page')

    if (enableContentTile) {
      dispatch({ type: "UPDATE_INITIAL_PAGINATION_PARAMS", payload: { enableContentTile: true, length: isMobile ? 50 : 102, fetchedProductsCount: isMobile ? 50 : 102 } })
    }

    if (pageNumberInURL) {
      dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: Number(pageNumberInURL), shouldChangeURL: false } })
    }

    setRenderFromServer(false)

    if (window.innerWidth <= 1024) {
      setIsRequestingFromMobile(true)
    }

    // Listen for URL changes via the back button
    const handlePopState = () => {
      const newSearchParams = new URLSearchParams(window.location.search);
      const newPageNumber = newSearchParams.get('page');
      if (newPageNumber) {
        console.log("newPageNumber", newPageNumber)
        dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: Number(newPageNumber), shouldChangeURL: false } });
      } else {
        // if there is no page number, consider it be page 1
        dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: 1, shouldChangeURL: false } });
      }
    };

    window.addEventListener('popstate', handlePopState);

    setIsClient(true);

    //set customer nosto api
    setCustomer(logUser.user_loggedIn.accessToken);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      dispatch({ type: "RESET_PAGINATION_PARAMS", payload: defaultPaginationParams })
    }
  }, [])

  if (isClient&&(ContentTilePLP2 || ContentTilePLP1)) {
    removeTargetAttr();
  }

  // handle the state passed to Algolia
  const onStateChange = ({ uiState, setUiState }) => {
    // if coming back to a route where search params does not exist then pass initail state back to Algolia
    if(Object.keys(uiState).length === 0 || !uiState[indexName]){
      uiState = initState;
    }
    setUiState(uiState);
  };

  const isOliSearchPresent = () => {
    if (typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("search_source") === "oli_plp";
    }
    return false;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Check if detectedFilters exists in local storage
      const detectedFilters = localStorage.getItem("detectedFilters");

      // Check if the URL query parameter search_source=oli_plp exists
      const urlParams = new URLSearchParams(window.location.search);
      const searchSource = urlParams.get("search_source");

      if (detectedFilters && searchSource === "oli_plp") {
        let oli_filter = JSON.parse(detectedFilters);
        console.log("OLI Logs - user query:", oli_filter.user_query);
        console.log("OLI logs - Detected Filters:", oli_filter);
        // console.log("Search Source is oli_plp");
        // Perform your logic here
      }
    }
  }, []);

  return (<>
    {/*  Component for P1 brand module */}
    <div className={plpscroll ? `v-none` : ``}>
      <SuperbrandPLP />
    </div>
    <SeoDefinition seoData={seoDataa} />
    <InstantSearchSSRProvider
      {...serverState}>
      <InstantSearch
        searchClient={client}
        indexName={indexName}
        initialUiState={initState}
        // routing={myRouter}
        insights={true}
        onStateChange={onStateChange}
        routing={{
          router: createInstantSearchRouterNext({
            singletonRouter,
            serverUrl,
          }),
          stateMapping: {
            stateToRoute(uiState) {
              return {
                ...uiState,
                ...(isOliSearchPresent() ? { search_source: "oli_plp" } : {}), // Only include if initially present
              };
            },
            routeToState(routeState) {
              return {
                ...routeState,
                ...(routeState.search_source === "oli_plp" ? { search_source: "oli_plp" } : {}), // Retain only if it exists
              };
            },
          },
        }}
      > 
        <div className="plp-section auto-plp-container">
          <div className="breadcrumb-container">
          {!serverRender && <BreadCrumb attributes={breadcrumbAttributes} />}
           </div>
          <div className="container">
            <div className="ais-InstantSearch">
              <IntroComp seoData={seoDataa} oliSearch={oliSearch}/>
              {/* When offset and length is passed from server, pass those same to the Configure component */}
              
              <Configure
                offset={renderFromServer ? offset : paginationState.offset}
                length={renderFromServer ? isMobile ? 50 : length : paginationState.length}
                filters={configure?.filters} 
                clickAnalytics />

              <div className="plpQuickLinks">
              {quickLinks?.data && <PLPQuickLinks serverPath={serverPath}/>}
              </div>
              <div className="grid-md-12 filter-bar">
                {/* filter module */}
                <PLPFilter serverRender={serverRender} initialRefinement={initialRefinement} serverPath={serverPath} indexName={indexName} seoData={seoDataa} />
                {!serverRender && <TotalCount
                  shouldRender={false}
                  setTotalPages={(totalPages) => dispatch({ type: "ADD_TOTAL_PAGES_COUNT", payload: totalPages })}
                  setTotalFetchedProducts={
                    (totalFetchedProducts) => dispatch({ type: "ADD_TOTAL_PRODUCTS_COUNT", payload: totalFetchedProducts })
                  }
                  isUsedForPagination={true}
                  productsLengthPerPage={paginationState.productsLengthPerPage}
                  totalFetchedProducts={paginationState.totalFetchedProducts}
                  resetPagination={(newPageNo) => dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: newPageNo, shouldChangeURL: false } })}
                />}
                <div className='d-none'>
                  <SearchBox />
                </div>
                {/* sort module */}
                <SortComp serverPath={serverPath} dispatch={dispatch} />
              </div>
              {/* For no of items */}
              <div className="for-plp-loading"></div>
              <div className="injected-content">
                <InjectedInfiniteHits
                  position1={position1}
                  position2={position2}
                  hitComponent={HitComponent}
                  currentPage={paginationState.currentPage}
                  enableContentTile={enableContentTile}
                  slots={enableContentTile ? () => [
                    {
                      injectAt: ({ position }) =>
                        position === 0 ? false : position === position1,
                      slotComponent: (position1 && contentTilePLPOne && ContentTilePLP1)
                    },
                    {
                      injectAt: ({ position }) =>
                        position === 0 ? false : position === position2,
                      slotComponent: (position2 && contentTilePLPTwo && ContentTilePLP2)
                    }
                  ] : () => []}
                  isRequestingFromMobile={isRequestingFromMobile}
                  totalFetchedProducts={paginationState.totalFetchedProducts}
                  isOnlyMobile={isMobile}
                />

                {paginationState.totalPages > 1 ? (
                  <CustomMDesktopPagination dispatch={dispatch} paginationState={paginationState} />
                  ) : (
                    <></>
                    )}
              </div>
              <div className="nosto_element pl-none pr-none" id={isNewArrivalsPLP ? "new-arrivals-plp" : isCollectionPLP ? "collection-plp-all" : isDesignerPLP ? "designer-plp-all" : "category-plp-all"}
              ></div>
            </div>
          </div>
        </div>
      </InstantSearch>
    </InstantSearchSSRProvider>
  </>
  );
}

export default Collection;